import React from 'react';
import AppTitle from '../AppTitle';

const PrivacyPolicy = () => {
  return (
    <div>
      <AppTitle title={'Private Policy'} from={'Home'} to='Contact' link='/' />

      <div className='container custom-container mt-10'>
        <div className='row gy-6'>
          <div className='col-12 '>
            <div className='contact-section1_content'>
              {/* <h2 className='contact-section2__title'>OVERVIEW</h2> */}
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                At Say Cheeze Cakes, we value your privacy and are committed to protecting your
                personal information. This Privacy Policy outlines how we collect, use, and
                safeguard your data.
                <br />
                When you interact with us—whether by placing an order, contacting us, or visiting
                our website—we may collect certain personal details such as your name, phone number,
                email address, delivery address, and any customisation requests. If you make a
                payment, your payment details are securely processed through trusted gateways.
                <br />
                We use this information to fulfill your orders, communicate important updates like
                confirmations or delays, respond to queries, and occasionally send promotional
                offers—but only if you’ve given us permission. We never sell or rent your personal
                data. Your information may only be shared with trusted third-party services like our
                delivery partners and payment processors to complete your orders safely and
                efficiently.
                <br />
                We are committed to safeguarding your data using reasonable technical and
                organizational security measures. All payment information is handled via encrypted
                and secure platforms to prevent misuse or unauthorized access.
                <br />
                As a customer, you have the right to access, correct, or request deletion of your
                data. You can also opt out of marketing communication at any time by contacting us
                or unsubscribing.
                <br />
                To enhance your browsing experience, we may use cookies on our website. These
                cookies help us understand how users interact with our site but do not collect
                personal information unless you voluntarily provide it.
                <br />
                If you have questions or concerns about how your data is handled, you can contact us
                at:
                <br />
                📧{' '}
                <a href='mailto:saycheezecakes@gmail.com' target='_blank' rel='noopener'>
                  <b> saycheezecakes@gmail.com</b>
                </a>
                <br />
                📞{' '}
                <a href='tel:9945423080'>
                  <b>+91 99454 23080</b>
                </a>
                {/* 📞 9945423080 */}
              </p>
            </div>
            {/* <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>OVERVIEW</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                This Privacy Policy describes how your personal information is collected, used, and
                shared when you visit or make a purchase from www.saycheezecakes.com (the “Site”).
                <br />
                <br />
                <b>PERSONAL INFORMATION WE COLLECT</b>
                <br />
                When you visit the Site, we automatically collect certain information about your
                device, including information about your web browser, IP address, time zone, and
                some of the cookies that are installed on your device. Additionally, as you browse
                the Site, we collect information about the individual web pages or products that you
                view, what websites or search terms referred you to the Site and information about
                how you interact with the Site. We refer to this automatically-collected information
                as “Device Information.”
                <br />
                <br />
                <b>We collect Device Information using the following technologies:</b>
                <br />
                - “Cookies” are data files that are placed on your device or computer and often
                include an anonymous unique identifier. For more information about cookies, and how
                to disable cookies, visit https://www.saycheezecakes.com.
                <br />
                - “Log files” track actions occurring on the Site, and collect data including your
                IP address, browser type, Internet service provider, referring/exit pages, and
                date/time stamps.
                <br />
                - “Web beacons,” “tags,” and “pixels” are electronic files used to record
                information about how you browse the Site.
                <br />
                Additionally, when you make a purchase or attempt to make a purchase through the
                Site, we collect certain information from you, including your name, billing address,
                shipping address, payment information is collected for the secured payment Gateway
                (including credit card numbers), email address, and phone number. We refer to this
                information as “Order Information.”
                <br />
                When we talk about “Personal Information” in this Privacy Policy, we are talking
                both about Device Information and Order Information.
                <br />
                <br />
                <b>HOW DO WE USE YOUR PERSONAL INFORMATION?</b>
                <br />
                We use the Order Information that we collect generally to fulfil any orders placed
                through the Site (including processing your payment information, arranging for
                shipping, and providing you with invoices and/or order confirmations). Additionally,
                we use this Order Information to: Communicate with you; Screen our orders for
                potential risk or fraud; and When in line with the preferences you have shared with
                us, provide you with information or advertising relating to our products or
                services.
                <br />
                We use the Device Information that we collect to help us screen for potential risk
                and fraud (in particular, your IP address), and more generally to improve and
                optimize our Site (for example, by generating analytics about how our customers
                browse and interact with the Site, and to assess the success of our marketing and
                advertising campaigns).
                <br />
                <br />
                <b>SHARING YOUR PERSONAL INFORMATION </b>
                <br />
                We share your Personal Information with third parties to help us use your Personal
                Information, as described above. For example, we use Shopify platform to power our
                online store. We also use Google Analytics to help us understand how our customers
                use the Site--you can read more about how Google uses your Personal Information
                here: https://www.google.com/intl/en/policies/privacy/. You can also opt-out of
                Google Analytics here: https://tools.google.com/dlpage/gaoptout.
                <br />
                Finally, we may also share your Personal Information to comply with applicable laws
                and regulations, to respond to a subpoena, search warrant or other lawful requests
                for information we receive, or to otherwise protect our rights.
                <br />
                <br />
                <b>DO NOT TRACK</b>
                <br />
                Please note that we do not alter our Site’s data collection and use practices when
                we see a Do Not Track signal from your browser.
                <br />
                <br />
                <b>DATA RETENTION</b>
                <br />
                When you place an order through the Site, we will maintain your Order Information
                for our records unless and until you ask us to delete this information.
                <br />
                <br />
                <b>MINORS</b>
                <br />
                The Site is not intended for individuals under the age of 16.
                <br />
                <br />
                <b>CHANGES</b>
                <br />
                We may update this privacy policy from time to time in order to reflect, for
                example, changes to our practices or for other operational, legal or regulatory
                reasons.
                <br />
                <br />
                <b>CONTACT US</b>
                <br />
                For more information about our privacy practices, if you have questions, or if you
                would like to make a complaint, please contact us by e-mail at
                saycheezecakes@gmail.com or by mail using the details provided below:
                <br />
                <b>
                  Flat 303, Monte Tabor 3rd cross, Off K Narayanapura Main Road, Bengaluru Urban,
                  Karnataka, India - 560077
                </b>
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
